import { apiCheckUniqueIdentity } from '@/network/api/api';
import Province from '@components/Province';
import type { FormInstance } from 'antd';
import { Form, Input, Select } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { GradeEnum } from '../constants';

interface ScenicInfoFormProps {
  formRef: FormInstance;
  formData: React.MutableRefObject<any[]>;
  currentStep: number;
  onFinish: (title?: string) => void;
  setCanGoLogin: (v: boolean) => void;
}

const ScenicInfoForm: React.FC<ScenicInfoFormProps> = ({
  formRef,
  formData,
  currentStep,
  onFinish,
  setCanGoLogin,
}) => {
  return (
    <Form layout="vertical" form={formRef} size="large" onFinish={onFinish}>
      <FormItem label="景区名称" name="scenicName" rules={[{ required: true, message: '请输入' }, { max: 50 }]}>
        <Input placeholder="请输入" />
      </FormItem>
      <FormItem label="景区等级" name="grade">
        <Select options={GradeEnum} placeholder="请选择" />
      </FormItem>
      <FormItem label="景区所在地（省市区）" name="scenicProvince">
        <div key="province">
          <Province
            value={() => {
              const data = formData.current[currentStep];
              if (data == undefined) {
                return [];
              }
              const province = data.scenicProvince;
              if (province == undefined) {
                return [];
              }
              return [province.provinceName, province.cityName, province.areaName];
            }}
            width="100%"
            onChange={(e: any) => {
              const provinceData = {
                provinceName: e?.[0]?.addressName,
                provinceCode: e?.[0]?.addressId,
                cityName: e?.[1]?.addressName,
                cityCode: e?.[1]?.addressId,
                areaName: e?.[2]?.addressName,
                areaCode: e?.[2]?.addressId,
              };
              formRef.setFieldValue('scenicProvince', provinceData);
            }}
          />
        </div>
      </FormItem>
      <FormItem label="详细地址" name="address" rules={[{ max: 100 }]}>
        <Input placeholder="请输入" />
      </FormItem>
      <FormItem
        label="英文/拼音简称"
        name="uniqueIdentity"
        validateTrigger="onChange"
        rules={[
          {
            required: true,
            validator: async (_, value) => {
              // 判断纯英文输入
              if (value && value.length <= 20 && /^[a-zA-Z]+$/.test(value)) {
                const { data }: any = await apiCheckUniqueIdentity(value);
                if (data) {
                  //true表示已经占用
                  setCanGoLogin(true); //直接可以登录
                  return Promise.reject('此景区已注册，请直接登录！');
                } else {
                  setCanGoLogin(false);
                  return Promise.resolve();
                }
              } else {
                setCanGoLogin(false);
                return Promise.reject('请输入英文/拼音简称');
              }
            },
          },
        ]}
      >
        <Input maxLength={20} placeholder="将作为访问地址唯一标识，不可更改！" />
      </FormItem>
    </Form>
  );
};

export default ScenicInfoForm;
